import firebase from '../firebase';
import { SHOW_TOAST } from './types';

/**
 * const typestoEnd = {
    'Link':'urls',
    'Video':'videos',
    'podcast':'podcasts',
    'Photo':'photos',
  }
var database = firebase.database();
								database.ref(this.thetype+'/'+this.itemid+'/'+typestoEnd[itemType]+'/'+ itemID).remove();

*/

export const deletePostAttachment = (params) => {
	return (dispatch, getState) => {
		var updates = {};
		var postPath = '';
		var attachmentPath = '';

		let deletePath = {
			postType: {
				thoughts: 'dailyThoughts',
				articles: 'news',
				groups: 'company-group-posts'
			},
			attachmentType: {
				urls: 'urls',
				videos: 'videos',
				podcasts: 'podcasts',
				photos: 'photos',
				files: 'files',
			}
		};

		if (params.post && params.post.groupid.length > 0) {
			postPath = `${deletePath.postType['groups']}/${params.post.companyID}/${params.postID}`;
			attachmentPath = `${deletePath.attachmentType[params.attachmentType]}/${params.attachmentID}`;


			updates[`${postPath}/${attachmentPath}`] = null;
			updates[`group-posts/${params.post.groupid}/${params.postID}/${attachmentPath}`] = null;
			updates[`groupfiles/${params.post.groupid}/${params.attachmentID}`] = null;

			if (params.attachmentType === 'files') {
				updates['files/' + params.attachmentID] = null;
			}
		} else {
			postPath = `${deletePath.postType[params.postType]}/${params.postID}`;
			attachmentPath = `${deletePath.attachmentType[params.attachmentType]}/${params.attachmentID}`;
			updates[`${postPath}/${attachmentPath}`] = null;
		}


		// Helper: after deleting an attachment, if the test was created from a transcript for this post, delete its survey and reset stage
		const maybeDeleteTranscriptTest = async () => {
			try {
				const db = firebase.database;
				const companyID = params.post.real_companyID || params.post.companyID;
				const surveyRef = db.ref(`surveys/${companyID}/${params.postID}`);
				const snapshot = await surveyRef.once('value');
				const survey = snapshot.val();
				if (survey && (survey.testSource === 'transcript' || survey.sourceMeta?.usedTranscript)) {
					// Remove the survey and reset stage back to 1 (no active test)
					const cleanup = {};
					cleanup[`surveys/${companyID}/${params.postID}`] = null;
					if (params.post && params.post.groupid && params.post.groupid.length > 0) {
						// For group posts, reset both company-group and group-posts stage
						cleanup[`company-group-posts/${params.post.companyID}/${params.postID}/stage`] = 1;
						cleanup[`group-posts/${params.post.groupid}/${params.postID}/stage`] = 1;
					} else {
						cleanup[`dailyThoughts/${params.postID}/stage`] = 1;
					}
					await db.ref().update(cleanup);
				}
			} catch (e) {
				// Non-fatal: log and continue
				
			}
		};

		// Do a deep-path update
		firebase.database.ref().update(updates, async function(error) {
			if (error) {
				dispatch({
					type: SHOW_TOAST,
					variant: 'error',
					message: error.message
				});
			} else {
				await maybeDeleteTranscriptTest();
				dispatch({
					type: SHOW_TOAST,
					variant: 'success',
					message: 'Attachment deleted successfully!!'
				});
				dispatch({
					type: 'DELETE_POST_ATTACHMENT',
					message: `${params.postType} attachment deleted!!`
				});
			}
		});

		// firebase.database
		// 	.ref(`${postPath}/${attachmentPath}`)
		// 	.remove()
		// 	.then((res) => {
		// 		dispatch({
		// 			type: SHOW_TOAST,
		// 			variant: 'success',
		// 			message: 'Attachment deleted successfully!!'
		// 		});
		// 		dispatch({
		// 			type: 'DELETE_POST_ATTACHMENT',
		// 			message: `${params.postType} attachment deleted!!`
		// 		});
		// 	})
		// 	.catch((err) => {
		// 		dispatch({
		// 			type: SHOW_TOAST,
		// 			variant: 'error',
		// 			message: err.message
		// 		});
		// 	});
	};
};
